export class GlobalComponentsIndex {
    private componentIndex: number
    constructor() {
        this.componentIndex = 0
    }

    public get(): number {
        return this.componentIndex
    }

    public incrementAndGet(): number {
        return ++this.componentIndex
    }

    public reset(): void {
        this.componentIndex = 0
    }
}

export const globalComponentsIndex = new GlobalComponentsIndex()
